// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"727987c3","277":"54a2b14b","822":"bbc7b6f3"}[chunkId] + ".chunk.js";
};